'use client'

import dynamic from 'next/dynamic'
import { useSearchParams } from 'next/navigation'
import React, { useState } from 'react'

import { DonateSelectionScreen } from './DonateSelectionScreen'
import { PaymentSuccessScreen } from './PaymentSuccessScreen'

import { Skeleton } from '@/components/ui/skeleton'

// Code-split so @stripe/react-stripe-js only loads when the user reaches the
// payment step.
const StripePaymentScreen = dynamic(
  () => import('./StripePaymentScreen').then((m) => m.StripePaymentScreen),
  { ssr: false, loading: () => <Skeleton className="h-96 w-full rounded-xl" /> },
)

const DonateForm: React.FC = () => {
  const searchParams = useSearchParams()

  const paymentSuccess = searchParams.get('payment-success')
  const [clientSecret, setClientSecret] = useState<string | null>(null)
  const [showSuccess, setShowSuccess] = useState(paymentSuccess === 'true')

  const donationAmounts = [5, 25, 100, 500, 5000]
  const suggestedDonation = 500

  return (
    <div className="flex flex-col">
      {showSuccess ? (
        <PaymentSuccessScreen />
      ) : clientSecret ? (
        <StripePaymentScreen clientSecret={clientSecret} onSuccess={() => setShowSuccess(true)} />
      ) : (
        <DonateSelectionScreen
          donationAmounts={donationAmounts}
          suggestedDonation={suggestedDonation}
          setClientSecret={setClientSecret}
        />
      )}
    </div>
  )
}

export default DonateForm
